import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { setToastSettings } from '@/lib/toast';
import { ToastSettings } from '@/types/toast';

export function useToastSettings() {
    const [settings, setSettings] = useState<ToastSettings>({});
    const [loading, setLoading] = useState(true);

    const fetchSettings = async () => {
        try {
            const { data, error } = await supabase
                .from('app_configuration' as any)
                .select('value')
                .eq('key', 'toast_settings')
                .single();

            if (error) {
                if (error.code === 'PGRST116') {
                    // Setting doesn't exist yet, use defaults
                    console.log('No toast_settings found in app_configuration, using defaults.');
                    setToastSettings({});
                    setSettings({});
                } else {
                    throw error;
                }
            } else {
                const configData = data as any;
                const value = configData.value as ToastSettings;
                setToastSettings(value || {});
                setSettings(value || {});
            }
        } catch (err) {
            console.error('Failed to fetch toast settings:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSettings();

        // Set up real-time subscription for toast_settings changes
        const channel = supabase
            .channel('public:app_configuration')
            .on(
                'postgres_changes',
                {
                    event: '*',
                    schema: 'public',
                    table: 'app_configuration',
                    filter: "key=eq.toast_settings",
                },
                (payload) => {
                    if (payload.new) {
                        const value = (payload.new as any).value as ToastSettings;
                        setToastSettings(value);
                        setSettings(value);
                    }
                }
            )
            .subscribe();

        return () => {
            supabase.removeChannel(channel);
        };
    }, []);

    return { settings, loading, refresh: fetchSettings };
}
